// Permite números decimales con hasta 2 decimales.
// Ejemplos válidos: "123", "123.4", "123.45"
// ^\d*      → Cero o más dígitos antes del punto.
// \.?       → Un punto opcional.
// \d{0,2}$  → De 0 a 2 dígitos después del punto.
export const REGEX_DECIMAL = /^\d*\.?\d{0,2}$/;

// Permite solo números enteros positivos (sin decimales ni signos).
// ^\d+$ → Uno o más dígitos, desde el inicio hasta el final.
export const REGEX_ENTERO = /^\d+$/;

// Valida un email en formato básico.
// ^[^\s@]+    → Uno o más caracteres que no sean espacio ni "@"
// @           → Debe contener un "@"
// [^\s@]+     → Uno o más caracteres que no sean espacio ni "@"
// \.          → Un punto literal
// [^\s@]+$    → Uno o más caracteres que no sean espacio ni "@"
export const REGEX_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Permite solo letras (mayúsculas o minúsculas) y espacios.
// ^[a-zA-Z\s]+$ → Uno o más caracteres alfabéticos o espacios.
export const REGEX_ONLY_LETTERS = /^[a-zA-Z\s]+$/;

// Permite letras y números, con espacios.
// ^[a-zA-Z0-9\s]+$ → Uno o más caracteres alfanuméricos o espacios.
export const REGEX_ALPHANUMERIC = /^[a-zA-Z0-9\s]+$/;

// Valida un DNI argentino (7 u 8 dígitos).
// ^\d{7,8}$ → Exactamente 7 u 8 dígitos.
export const REGEX_DNI = /^\d{7,8}$/;

// Valida un número de teléfono con entre 10 y 15 dígitos.
// ^[0-9]{10,15}$ → Exactamente de 10 a 15 dígitos seguidos.
export const REGEX_PHONE = /^[0-9]{10,15}$/;

// Valida un CUIT/CUIL argentino (exactamente 11 dígitos).
// ^[0-9]{11}$ → Exactamente 11 dígitos seguidos.
export const REGEX_CUIT = /^\d{0,11}$/;

// Permite números enteros positivos con máximo 10 dígitos.
// ^\d{1,10}$ → De 1 a 10 dígitos.
export const REGEX_NUMBER = /^\d{1,10}$/;